/**
 * 是否是钉钉环境
 */
export function isDingTalk(): boolean {
    return globalThis.navigator && /dingtalk/i.test(globalThis.navigator.userAgent);
}
